import { render, staticRenderFns } from "./LaundryPickupActions.vue?vue&type=template&id=158afc7c&scoped=true"
import script from "./LaundryPickupActions.vue?vue&type=script&lang=js"
export * from "./LaundryPickupActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158afc7c",
  null
  
)

export default component.exports